/* Установщик «Текст»: объект в window на том месте порядка скриптов, где стоял assets/bot-text.js.
   В серверном режиме движок шаблона получает сервер экрана (text-server.ts) и экран text встаёт в реестр движков студии; выбирает его только
   список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). Глобальный BotText — фасад:
   - open(хозяин, вход) с элементом — движок (кадр студии EngineFrame); без элемента — вход ведёт в студию (как заглушка);
   - setup и fill — переходы в студию, как у прежней заглушки (точное приложение после загрузки старого каркаса не сбивается);
   - improveInline — «Улучшить» полей описания других экранов движка (BotCore.improveBtn) через сервер (engine-kit/improve-service.ts):
     BotCore не доходит до своих демо-вариантов (план M3, D3); описания товара данными (seo) в серверном режиме нет. */
import { createText } from './engine';
import { isServerMode } from '../../platform/server-mode';
import { improveInline } from '../studio/engine-kit/improve-service';
import { openStudioTarget } from '../studio/studio-navigation';
import { createTextServer, registerTextEngine } from './text-server';

interface TextEngine {
  init(o?: unknown): void;
  open(host: HTMLElement, o: Record<string, unknown>): void;
  close(): void;
  readonly mounted: boolean;
  readonly run: unknown;
  S: unknown;
  TONES?: unknown;
}

export function installText() {
  if (isServerMode()) {
    createText(createTextServer);
    registerTextEngine();
    const engine = (window as unknown as { BotText?: TextEngine }).BotText ?? null;
    const target = (value: unknown) => {
      const options = value && typeof value === 'object' ? (value as Record<string, unknown>) : {};
      // Bootstrap старого каркаса вызывает setup/open без параметров после точного native target.
      if (!Object.keys(options).length) return;
      openStudioTarget({ screen: 'text', options });
    };
    Object.assign(window, {
      BotText: {
        init(o?: unknown) {
          engine?.init(o);
        },
        setup: target,
        open(host: unknown, options: unknown) {
          if (engine && typeof HTMLElement !== 'undefined' && host instanceof HTMLElement)
            engine.open(host, options && typeof options === 'object' ? (options as Record<string, unknown>) : {});
          else target(options);
        },
        close() {
          engine?.close();
        },
        fill(flag: string) {
          if (/^#studio\.[^.]+\.(?:.*\.)?native_app_[1-9][0-9]*(?:\.|$)/.test(location.hash)) return;
          const mode = flag.replace(/^tt/, '');
          if (['stt', 'seo', 'pnew', 'pphoto', 'pfix'].includes(mode)) target({ tool: mode });
        },
        after() {},
        flagSetup() {
          return {};
        },
        improveInline,
        seo: null,
        get TONES() {
          return engine?.TONES ?? [];
        },
        get mounted() {
          return !!engine?.mounted;
        },
        get run() {
          return engine ? engine.run : false;
        },
        get S() {
          return engine?.S ?? {};
        },
        PREFIX: 'tt',
        TESTS: [],
      },
    });
    return;
  }
  createText();
}
